export default {
  labels: {
    today: 'Dziś',
    pickup_time: 'Czas odbioru',
    delivery_time: 'Czas dostawy',
  },
};
